import { createSlice } from '@reduxjs/toolkit'
import { t } from 'i18next'

export const qrSlice = createSlice({
  name: 'qr',
  initialState: {
    qrGenStep: 1,
    qrCodes: {
      result: [],
      totalCount: 0
    },
    qrCode: {
      id: null,
      userId: null,
      content: null,
      title: t('Untitled'),
      type: null,
      subType: 'dynamic',
      identifier: null,
      viewCount: 0,
      isSaved: 0,
      groupId: 0,
      groupName: '',
      isArchived: 0,
      dtCreated: null,
      dtUpdated: null,
      image: null,
      bgColor: '#ffffff',
      bgTransparent: 0,
      dotColor: '#000000',
      gradient: null,
      secondColor: '#ffffff',
      cornerBorderColor: '#000000',
      cornerCenterColor: '#000000',
      dotShape: 'square',
      cornerBorderShape: 'square',
      cornerCenterShape: 'square',
      logo: null,
      logoBgTransparent: 0,
      frame: null,
      frameColor: '#000000',
      framePhrase: 'SCAN ME',
      framePhraseFont: 'Calibri',
      isActive: 0
    },
    qrCodeType: {},
    isEditing: false,
    initialEditing: false,
    isUpdating: false,
    dashboard: 'dashboard',
    logoFile: null,
    prevLogoUrl: null,
    newGroupModalShow: false,
    chooseGroupModalShow: false,
    bulkCreationModalShow: false,
    newGroupName: '',
    delGroupModalShow: false,
    groups: [],
    group: { content: 'empty' },
    isGroupEditing: false,
    savedQRCodeDesigns: [],
    isStaticQRCodeContentValidating: false,
    staticQRCodeContentError: true,
  },
  reducers: {
    initQRGenStep(state, action) {
      state.qrGenStep = 1
    },
    increaseQRGenStep(state, action) {
      if (state.qrGenStep < 4) {
        state.qrGenStep++
      }
    },
    decreaseQRGenStep(state, action) {
      if (state.qrGenStep > 0) {
        state.qrGenStep--
      }
    },
    setQRGenStep(state, action) {
      state.qrGenStep = action.payload
    },
    setQRCodeType(state, action) {
      state.qrCodeType = action.payload
    },
    setQRCodes(state, action) {
      state.qrCodes = action.payload
    },
    setQRCode(state, action) {
      state.qrCode = action.payload
    },
    setQRCodeField(state, action) {
      state.qrCode[action.payload.key] = action.payload.val
    },
    setDefaultTitle(state) {
      state.qrCode.title = t('Untitled');
    },
    setSavedQRCodeDesigns(state, action) {
      state.savedQRCodeDesigns = action.payload
    },
    setQRCodePreviewText(state, action) {
      state.qrCodePreviewText = action.payload
    },
    setIsEditing(state, action) {
      state.isEditing = action.payload
    },
    setIsUpdating(state, action) {
      state.isUpdating = action.payload
    },
    setLogoFile(state, action) {
      state.logoFile = action.payload
    },
    setPrevLogoUrl(state, action) {
      state.prevLogoUrl = action.payload
    },
    setGroupModalShow(state, action) {
      state.newGroupModalShow = action.payload
    },
    setDelGroupModalShow(state, action) {
      state.delGroupModalShow = action.payload
    },
    setNewGroupName(state, action) {
      state.newGroupName = action.payload
    },
    setGroups(state, action) {
      state.groups = action.payload
    },
    setGroup(state, action) {
      state.group = action.payload
    },
    setIsGroupEditing(state, action) {
      state.isGroupEditing = action.payload
    },
    setChooseGroupModalShow(state, action) {
      state.chooseGroupModalShow = action.payload
    },
    setDashboard(state, action) {
      state.dashboard = action.payload
    },
    setBulkCreationModalShow(state, action) {
      state.bulkCreationModalShow = action.payload
    },
    setInitialEditing(state, action) {
      state.initialEditing = action.payload
    },
    setIsStaticQRCodeContentValidating(state, action) {
      state.isStaticQRCodeContentValidating = action.payload
    },
    setStaticQRCodeContentError(state, action) {
      state.staticQRCodeContentError = action.payload
    },
    initializeQRCode(state, action) {
      state.qrCode = {
        id: null,
        userId: null,
        content: null,
        title: t('Untitled'),
        type: null,
        subType: 'dynamic',
        identifier: null,
        viewCount: 0,
        isSaved: 0,
        groupId: 0,
        groupName: '',
        isArchived: 0,
        dtCreated: null,
        dtUpdated: null,
        image: null,
        bgColor: '#ffffff',
        bgTransparent: 0,
        dotColor: '#000000',
        gradient: null,
        secondColor: '#ffffff',
        cornerBorderColor: '#000000',
        cornerCenterColor: '#000000',
        dotShape: 'square',
        cornerBorderShape: 'square',
        cornerCenterShape: 'square',
        logo: null,
        logoBgTransparent: 0,
        frame: null,
        frameColor: '#000000',
        framePhrase: 'SCAN ME',
        framePhraseFont: 'Calibri',
        isActive: 0
      }
    },
    initialize(state, action) {
      state.qrCodeType = {}
      state.qrCodes = []
      // state.qrCode = {}
      // state.groups = []
      // state.group = {}
      state.qrCodePreviewText = undefined
      state.logoFile = undefined
      state.search = undefined
    },
  }
})

export const {
  initQRGenStep,
  increaseQRGenStep,
  decreaseQRGenStep,
  setQRCodeField,
  setDefaultTitle,
  setQRCodes,
  setQRCode,
  initialize,
  setQRCodePreviewText,
  setQRGenStep,
  setQRCodeType,
  setIsEditing,
  setIsUpdating,
  setLogoFile,
  setPrevLogoUrl,
  setGroupModalShow,
  setNewGroupName,
  setGroups,
  setGroup,
  setChooseGroupModalShow,
  setDashboard,
  setIsGroupEditing,
  initializeQRCode,
  setDelGroupModalShow,
  setBulkCreationModalShow,
  setSavedQRCodeDesigns,
  setInitialEditing,
  setIsStaticQRCodeContentValidating,
  setStaticQRCodeContentError,
} = qrSlice.actions
export default qrSlice.reducer